import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import classes from "./tiles.module.scss";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import store from "../../store/store";
import Error from "../../Shared/Layout/Error";
import availabilityIcon from "../../Resources/homepage/availabilityicon.png";
import seIcon from "../../Resources/homepage/sptab/BLOOM-Special-Events.png";
import { constants, environmentVariables } from "../../Shared/Url/Constants.js";
import herobannerimg from "../../Resources/herobanner/Maskgroup.png";
import {messages} from "../../Shared/Messages/ErrorMessages";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../Shared/Utill/AuthUtil";
import { convertDateToIsoString } from "../../Shared/Utill/Utills";
import { workScheduleActions, ODSFutureActions } from "../../store/store";
//import controlIcon from "../../Resources/homepage/sptab/Controls.png";
import { cutOffDateActions } from "../../store/store";
import { Button } from '@mui/material';
import { personActions } from "../../store/store";
//import AccomTileIcon from "../../Resources/homepage/sptab/AccomTileIcon.png";
import { PeopleIcon, SettingsOutlinedIcon } from '@genesis/ui-kit/dist/icons'; 
import moment from "moment";

const Tiles = (props) => {
  const navigate = useNavigate();

  const [isAppActive, setIsAppActive] = useState("True");
  const [inActivereason, setInActivereason] = useState("Error");
  const [isEventActive, setIsEventActive] = useState(true);
  const [activeApps, setActiveApps] = useState([]);
  const personDetails = useSelector((state) => state.person.personData);
  const token = Cookie.get('X_TKN');
  console.log("PROP VERSION OF URLS ",JSON.stringify(props.urlLocalState));
  const urlReduxDetails =  useSelector((state) => state.url.urlData);
  console.log("Redux VERSION OF URLS ",JSON.stringify(urlReduxDetails));
  const urlDetails = Object.keys(urlReduxDetails).length > 0 ? urlReduxDetails: props.urlLocalState;
  const [activeEvents, setactiveEvents] = useState([]);
  const [isEventsVisible, setIsEventsVisible] = useState(false);
  const [isEverythingHidden, setisEverythingHidden] = useState(false);
  const [todaysDate, setTodaysDate] = React.useState(convertDateToIsoString(new Date()));
  const [businessDate, setBusinessDate] = React.useState(new Date());
  const personStaticDetails = useSelector((state) => state.personStatic.personStaticData);
  const history = useNavigate();
  let tileCounter = 0;
  const [tileCount,setTileCount] = useState(tileCounter);
  const [tileRowCount,setTileRowCount] = useState((window.innerWidth >= 768 && window.innerWidth <= 1300) ? 2: 3);
  const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);
  const updateMedia = () => {
   if(window.innerWidth >= 768 && window.innerWidth <= 1300){
    setTileRowCount(2);
   }else{
    setTileRowCount(3);
   }

 };

 useEffect(() => {

  console.log("******",personStaticDetails.avail_accommodations);
   window.addEventListener("resize", updateMedia);
   return () => window.removeEventListener("resize", updateMedia);
 });

  useEffect(() => {
    console.log("Redux State ",store.getState());
    //alert("comes in tiles")
    getWorkSchedule();

    if(Object.keys(personODSFuture).length === 0){
      return;
    }
    const data = {
      //tkn:personDetails.cookiez.posting_TKN,
      // divNbr: personDetails.mydiv,
      // locNbr: personDetails.mystore,
      // dpt: personDetails.mydept,
      // ws: personDetails.workschedule,
      divNbr: personODSFuture.mydiv,
      locNbr: personODSFuture.mystore,
      dpt: personODSFuture.mydept,
      ws: personODSFuture.myworkschedule,
    }; 
      
    const eventData = 
      {
       // tkn:personDetails.cookiez.posting_TKN,
        divNbr: personODSFuture.mydiv,
        locNbr: personODSFuture.mystore,
        dpt: personODSFuture.mydept,
        myWorkSchedule: personODSFuture.myworkschedule,
        myDateDisplayed : "",
        ascNbr: personDetails.emplID,
    } 

  
    
    if (personDetails.empStatus !== "Terminated") {
        axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLAPPS}`, data, {
          headers: {
            'content-type': 'application/json',
            'Authorization':'Bearer ' + token
          }
        })
        .then((response) => {
         
        console.log("------",response.data);
        

        setActiveApps(response.data)
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLAPPS}...failed`})
        }
      })

      // get all events api
      axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLEVENTS}`, eventData, {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
       //TODO: uncomment below line and comment above to run locally 
      
        
        console.log("-----event", response.data)
        let data = response.data;
        let active = false;
        active = data.some(obj => obj.result === "True"); 
        setIsEventsVisible(active);
        setactiveEvents(data);
        
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLEVENTS}...failed`})
        }
      });

      let dateData = {
        // divNbr: personDetails.mydiv,
        // appAbbr: "AVL",
        // locNbr: personDetails.mystore,
        // dptNbr : personDetails.mydept,
        // myWorkSchedule: personDetails.workschedule,
        // minified:0,
        divNbr: personODSFuture.mydiv,
        appAbbr: "AVL",
        locNbr: personODSFuture.mystore,
        dptNbr : personODSFuture.mydept,
        myWorkSchedule: personODSFuture.myworkschedule,
        minified:0,
        today: moment().format("YYYY-MM-DD"),
      }

     

      // get first available edit date
      axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_AVL_FIRST_EDIT_DATE}`, dateData , {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
        store.dispatch(cutOffDateActions.resetCutOffDateState());
       
        let data = response.data[0].calDate;
        setBusinessDate(data)
        let cutOffData = {};
        cutOffData = {...response.data[0]}
        store.dispatch(cutOffDateActions.setCutOffDateState(cutOffData ));
        
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_GET_AVL_FIRST_EDIT_DATE}...failed`})
        }
      });  

    }else{
      setActiveApps([]);
      setIsEventsVisible(false);
      setactiveEvents([]);
    }
  }, []);

  useEffect(() => {

    if(Object.keys(personODSFuture).length === 0){
      return;
    }

    const data = {
     // tkn:personDetails.cookiez.posting_TKN,
      // divNbr: personDetails.mydiv,
      // locNbr: personDetails.mystore,
      // dpt: personDetails.mydept,
      // ws: personDetails.workschedule,
      divNbr: personODSFuture.mydiv,
      locNbr: personODSFuture.mystore,
      dpt: personODSFuture.mydept,
      ws: personODSFuture.myworkschedule,
    }; 
      
    const eventData = 
      {
       // tkn:personDetails.cookiez.posting_TKN,
        divNbr: personODSFuture.mydiv,
        locNbr: personODSFuture.mystore,
        dpt: personODSFuture.mydept,
        myWorkSchedule: personODSFuture.myworkschedule,
        myDateDisplayed : "",
        ascNbr: personDetails.emplID,
    } 

    
    if (personDetails.empStatus !== "Terminated") {
        axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLAPPS}`, data, {
          headers: {
            'content-type': 'application/json',
            'Authorization':'Bearer ' + token
          }
        }).then((response) => { 
        //TODO: uncomment below line and comment above to run locally 
       

        setActiveApps(response.data)
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLAPPS}...failed`})
        }
      })

    // get all events api
      axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLEVENTS}`, eventData, {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
       //TODO: uncomment below line and comment above to run locally 
       
        console.log("-----event", response.data)
        let data = response.data;
        
        let active = false;
        active = data.some(obj => obj.result === "True"); 
        setIsEventsVisible(active);
        setactiveEvents(data);
        
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLEVENTS}...failed`})
        }
      });

      let dateData = {
        // divNbr: personDetails.mydiv,
        // appAbbr: "AVL",
        // locNbr: personDetails.mystore,
        // dptNbr : personDetails.mydept,
        // myWorkSchedule: personDetails.workschedule,
        // minified:0,
        // dptNbr: personDetails.mydept,
        divNbr: personODSFuture.mydiv,
        appAbbr: "AVL",
        locNbr: personODSFuture.mystore,
        dptNbr : personODSFuture.mydept,
        myWorkSchedule: personODSFuture.myworkschedule,
        minified:0,
        today: moment().format("YYYY-MM-DD"),
      }

      // get first available edit date for impersonation also
      axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_AVL_FIRST_EDIT_DATE}`, dateData , {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
        store.dispatch(cutOffDateActions.resetCutOffDateState());
       
        let data = response.data[0].calDate;
        setBusinessDate(data)
     
        let cutOffData = {};
        cutOffData = {...response.data[0]}
        store.dispatch(cutOffDateActions.setCutOffDateState(cutOffData ));
        
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_GET_AVL_FIRST_EDIT_DATE}...failed`})
        }
      });  
    }else{
      setActiveApps([]);
      setactiveEvents([]);
      setIsEventsVisible(false);
    }
    
    
  }, [personODSFuture]); 


  const getWorkSchedule = async () => {
    store.dispatch(workScheduleActions.resetWorkScheduleState());
    let data = [
      {
      ascNbr: 72119137,
      myDiv: 72,
      myStore: "0046",
      myDept: "0404",
      myworkschedule: "Default work schedule",
      effectiveDate: "2022-10-27",
      adjstddate: "1901-01-01"
      },
      {
        ascNbr: 72119137,
        myDiv: 72,
        myStore: "0046",
        myDept: "0404",
        myworkschedule: "Nov 27 to Dec 3 ",
        effectiveDate: "2022-11-27",
        adjstddate: "2022-11-27"
      },
      {
        ascNbr: 72119137,
        myDiv: 72,
        myStore: "0046",
        myDept: "0404",
        myworkschedule: "Dec 4 to Dec 10 ",
        effectiveDate: "2022-12-04",
        adjstddate: "2022-12-04"
      },
      {
        ascNbr: 72119137,
        myDiv: 72,
        myStore: "0046",
        myDept: "0404",
        myworkschedule: "Dec 11 to Dec 17 ",
        effectiveDate: "2022-12-11",
        adjstddate: "2022-12-11"
      },
      {
        ascNbr: 72119137,
        myDiv: 72,
        myStore: "0046",
        myDept: "0404",
        myworkschedule: "Dec 18 to Dec 24 ",
        effectiveDate: "2022-12-18",
        adjstddate: "2022-12-18"
      }
    
    ]
  
    

    axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${personDetails.emplID}`, {
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then((response) => {
       console.log("response is",response.data)
       let data = response.data;
       if (response.data.length === 0){
        console.log("ODS LENGTH ZERO- FROM TILE");
        store.dispatch(ODSFutureActions.resetODSFutureState());
        navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
        //throw new Error("Empty workSchedule");
        return;
       }
       store.dispatch(workScheduleActions.setWorkScheduleState([...data ]));

       //TODO: check this whether we ccan get multiple record or not
       const filterByExpiration = () => data.filter(({ adjstddate }) => new Date(adjstddate) <= new Date());
       let filter = filterByExpiration();
       var max = filter.length > 0 ? filter.reduce(function (a, b) { return a.adjstddate > b.adjstddate ? a : b; }) : null;
       console.log("max",max)
      store.dispatch(ODSFutureActions.setODSFutureState({...max}));

      })
      .catch((error) => {
        console.log("THROW ERROR"+ JSON.stringify(error));
         if(error.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else if(error.message === 'Empty workSchedule') {
          let data= {};
          store.dispatch(ODSFutureActions.resetODSFutureState());
          navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
        }
        else {
          history("/somethingwentwrong", {state:`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}${personDetails.emplID}...failedforTiles`})
          }
        // error
        // Todo: remove once api is up
       // store.dispatch(workScheduleActions.setWorkScheduleState([ ...data ])); 
        
      })
  };


  const stopImpersonatePersonHandler = () => {
    // call api to fetch impersonate persons details
    let adminUser = personDetails.impersonate_admin_id;
    
    try {
      //store.dispatch(personActions.resetPersonState())
      let url =
      `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_PERSON}/${adminUser}`;
        //`${urlDetails.uiEnvUrls.REACT_APP_WFM_WFMCOMMON_BASE_URL}person/${adminUser}`;
      //let url =
        //`${environmentVariables.wfmCommonApiUrl}person/${adminUser}`;    
      const response = axiosInstance
        .get(url, {
          headers: {
            'content-type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        })
        .then((response) => {
          if (response.status == 200) {
            /*console.log("success on person!")
          console.log("Person data: ") 
          console.dir((response.data)) */
            let data = response.data;
            store.dispatch(personActions.updatePersonState({ ...data }));
            store.dispatch(
              personActions.updatePersonState({ impersonate_admin_id: null })
            );

            //store.dispatch(workScheduleActions.resetWorkScheduleState());
            // calling this to fix the work schedule. Whenever stop impersonate is done need to update work schedule
            axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${adminUser}`, {
              headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })
              .then((response) => {
               console.log("response is",response.data)
               let data = response.data;
               if (response.data.length === 0){
                store.dispatch(ODSFutureActions.resetODSFutureState());
                navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
                //throw new Error("Empty workSchedule");
                return;
               }
               store.dispatch(workScheduleActions.setWorkScheduleState([...data ]));

               //TODO: check this whether we ccan get multiple record or not
               const filterByExpiration = () => data.filter(({ adjstddate }) => new Date(adjstddate) <= new Date());
               let filter = filterByExpiration();
               var max = filter.length > 0 ? filter.reduce(function (a, b) { return a.adjstddate > b.adjstddate ? a : b; }) : null;
               console.log("max",max)
              store.dispatch(ODSFutureActions.setODSFutureState({...max}));
            })
              .catch((error) => {
                if(error.message === 'Network Error') {
                  history("/somethingwentwrong", {state:`Please logout and try again `})
                }else if (error.message === 'Empty workSchedule') {
                  let data= {};
                  store.dispatch(ODSFutureActions.resetODSFutureState());
                  navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
                }
                else {
                  history("/somethingwentwrong", {state:`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${adminUser}...failedaftr`})
                  }
                
                
              }) 

            navigate("/");
          } // if
        }) // then
        .catch((error) => {
          // error logic
        }); // response catch
    } catch (error) {} // catch

    
  };

  function IncreaseCounter(){
      tileCounter = tileCounter + 1;
      setTileCount(tileCounter);
      return <></>
  }

  function ErrorViewForNoTiles(){    
    // use-case 1: If User EmpStatus == Terminated
    // use-case 2: If AppActive = false && EventACtive = False && User empStatue != Terminated
    // use-case 3: If AppActive == true but ActiveApp count = 0 & 
    // VisibileEVent is also False, and EmpStatus is not Terminated
    if(personDetails.empStatus === "Terminated"){
      return <Error
      message={messages.WFM_TERMINATED}
      variant="danger"
      style={{ marginTop: "38px" }}
    />
    }
    else if(isAppActive === "False" &&
    !isEventActive &&
    personDetails.empStatus !== "Terminated" && tileCount == 0){
          return <Error
          message={inActivereason}
          variant="danger"
          style={{ marginTop: "8px" }}
        />
    }
    else if(activeApps.length === 0 && !isEventsVisible && personDetails.empStatus !== "Terminated" && tileCount == 0){
        return <Error
        message={messages.WFM_NO_ACTIONS}
        variant="danger"
        style={{ marginTop: "38px" }}
      />
    }
    else{
      return <></>
    }
  }
  return (
    <>
      <section>
        <div style={{width: "100%"}}>
          <div
            className={classes.herobanner}
          ></div>
        </div>
      </section>
      {(activeApps.length > 0 || isEventsVisible) && (
      <div className="container-xl">
        <div className={classes.titledescription}>
          <div className={classes.titlepage}>
            <div><img src={availabilityIcon}></img></div>
            <h3>Availability</h3>
          </div>
          <div className={classes.titledescription}>
            <h5>
              You have the flexibility and ownership to take charge of your
              schedule.
            </h5>
          </div>
        </div>
      </div>
      )}
      <div className={tileCount <= tileRowCount ? classes.tiles_flex : classes.tiles}>
      {isEventsVisible && personDetails.empStatus !== "Terminated" && (
          <>
          {<IncreaseCounter/>}
            <div className={`${classes.tile} ${classes.preferred}`}>
              <div className={classes.setitle}>
                <h6>Special Events</h6>
                <div><img src={seIcon}></img></div>
              </div>
              <div className={classes.sedescription}>
                <p>
                  Special events are critical event days which may require
                  availability outside of normal hours of operation.
                </p>
              </div>
              <button
                className={classes.btnPrimary}
                onClick={() => navigate("/specialevents",{state:activeEvents})}
              >
                Special Events
              </button>
            </div>
          </>
        )}
        {(activeApps.find(o => o.appAbbr === 'avl') !== undefined ? activeApps.find(o => o.appAbbr === 'avl').result === "True" : null) && personDetails.empStatus !== "Terminated" && (
          <>
            {<IncreaseCounter/>}
            <div className={`${classes.tile} ${classes.preferred}`}>
              <div className={classes.setitle}>
                <h6>Availability Selections</h6>
                <div><img src={seIcon}></img></div>
              </div>
              <div className={classes.sedescription}>
                <p>
                  Availability selection gives you ownership and
                  flexibility to specify your desired weekly schedule.
                </p>
              </div>
              <button
                className={classes.btnPrimary}
                onClick={() => navigate("/availabilityselections",{state:businessDate})}
              >
                Availability Selections
              </button>
            </div>
          </>
        )}
        {(activeApps.find(o => o.appAbbr === 'pwh') !== undefined ? activeApps.find(o => o.appAbbr === 'pwh').result === "True" : null) && personDetails.empStatus !== "Terminated" && (
          <>
            {<IncreaseCounter/>}
            <div className={`${classes.tile} ${classes.preferred}`}>
              <div className={classes.setitle}>
                <h6>Availability Selections (PWH)</h6>
                <div><img src={seIcon}></img></div>
              </div>
              <div className={classes.sedescription}>
                <p>
                  Availability selection(PWH) gives you ownership and
                  flexibility to specify your desired weekly schedule.
                </p>
              </div>
              <button
                className={classes.btnPrimary}
                onClick={() => navigate("/availabilityselections")}
              >
                Availability Selections
              </button>
            </div>
          </>
        )}
        { (personStaticDetails.avail_admin === "A" || personStaticDetails.avail_admin === "D") && personDetails.empStatus !== "Terminated" &&
          <>
            {<IncreaseCounter/>}
            <div className={`${classes.tile} ${classes.preferred}`}>
              <div className={classes.setitle}>
                <h6>Controls</h6>
                <div><SettingsOutlinedIcon/></div>
              </div>
              <div className={classes.sedescription}>
                <p>
                  For admin use only.
                </p>
              </div>
              <button
                className={classes.btnPrimary}
                onClick={() => navigate("/controls")}
              >
                Controls
              </button>
            </div>
          </>
        }
        {/* Admin Accommodations Tile */}
        { (personStaticDetails.avail_accommodations === "Y" || personStaticDetails.avail_accommodations === "y") && personDetails.empStatus !== "Terminated" &&
          <>
            {<IncreaseCounter/>}
            <div className={`${classes.tile} ${classes.preferred}`}>
              <div className={classes.setitle}>
                <h6>Accommodations</h6>
                <div><PeopleIcon/></div>
              </div>
              <div className={classes.sedescription}>
                <p>
                Update records for the colleague accommodations.
                </p>
              </div>
              <button
                className={classes.btnPrimary}
                onClick={() => navigate("/accommodation")}
              >
                Accommodations
              </button>
            </div>
          </>
        }
        {/* Error view */}
        <ErrorViewForNoTiles/>
      </div>
    
    </>
  );
};

export default Tiles;